var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"timeline-item",style:(_vm.courseStyle)},[_vm._v("\n  "+_vm._s(_vm.presentTime)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }